import { USER_KEY } from '@gymaholic/packages'
import FormGroup from 'components/Form/Form.Group.js'
import Form from 'components/Form'
import Input from 'components/Input'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import updateTrainingUserAction from 'modules/training/modules/training-users/actions/update'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import React from 'react'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { defineMessages } from 'react-intl'
import { isPrivateEmailStringUtil } from 'packages/src'
import { View } from 'components/View.js'
import TextBodySmaller from 'components/TextBodySmaller.js'
import isEmailStringUtil from 'utils/string/is-email/index.js'
import getEmailProfileSelect from 'modules/profile/redux/selectors/get-email/index.js'
import updateEmailProfileAction from 'modules/profile/redux/actions/update-email/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

const messages = defineMessages({
  firstName: {
    id: 'CustomerInfoSubscriptionForm.firstName',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'CustomerInfoSubscriptionForm.lastName',
    defaultMessage: 'Last Name'
  },
  email: {
    id: 'CustomerInfoSubscriptionForm.email',
    defaultMessage: 'Email'
  },
  updateYourEmail: {
    id: 'CustomerInfoSubscriptionForm.updateYourEmail',
    defaultMessage: 'Update your email so you can receive important updates regarding your subscription'
  }
})

const ANALYTIC_EVENT = {
  UPDATE_PRIVATE_EMAIL: 'UPDATE_PRIVATE_EMAIL'
}

export function CustomerInfoSubscriptionForm () {
  const dispatch = useDispatch()
  const intl = useIntl()
  const user = useSelector(getCurrentTrainingUserSelect)
  const email = useSelector(getEmailProfileSelect)
  const [shouldShowEmail, setShouldShowEmail] = React.useState()
  const isPrivateEmail = isPrivateEmailStringUtil(email)
  const isEmail = isEmailStringUtil(email)

  const handleMount = () => {
    if (!isPrivateEmail) {
      return
    }

    logEventAnalyticsUtil(ANALYTIC_EVENT.UPDATE_PRIVATE_EMAIL, {
      email
    })

    setShouldShowEmail(true)
    dispatch(updateEmailProfileAction(''))
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  const handleChangeFirstName = (event, name, value) => {
    dispatch(
      updateTrainingUserAction({
        key: USER_KEY.FIRST_NAME,
        value
      })
    )
  }

  const handleChangeLastName = (event, name, value) => {
    dispatch(
      updateTrainingUserAction({
        key: USER_KEY.LAST_NAME,
        value
      })
    )
  }

  const handleChangeEmail = (event, name, value) => {
    dispatch(updateEmailProfileAction(value))
  }

  return (
    <>
      <Form>
        <FormGroup>
          <Input
            placeholder={formatMessageIntlUtil(intl, messages.firstName)}
            type='text'
            onChange={handleChangeFirstName}
            value={getValueReduxUtil(user, USER_KEY.FIRST_NAME)}
          />
        </FormGroup>

        <FormGroup>
          <Input
            placeholder={formatMessageIntlUtil(intl, messages.lastName)}
            type='text'
            onChange={handleChangeLastName}
            value={getValueReduxUtil(user, USER_KEY.LAST_NAME)}
          />
        </FormGroup>

        {
          !!shouldShowEmail && (
            <FormGroup>
              <View>
                <Input
                  colorType={!isEmail ? Input.COLOR_TYPE.ERROR : null}
                  placeholder={formatMessageIntlUtil(intl, messages.email)}
                  type='text'
                  onChange={handleChangeEmail}
                  value={email}
                />

                <TextBodySmaller mt>
                  {formatMessageIntlUtil(intl, messages.updateYourEmail)}
                </TextBodySmaller>
              </View>
            </FormGroup>
          )
        }
      </Form>
    </>
  )
}
